import { defineApi } from '@/utils/fetch';

import type { IPostRegisterDeviceData, IRegisterDeviceResponseData } from './typings';

export const DeviceApi = {
    postRegisterDevice: defineApi<IPostRegisterDeviceData, IRegisterDeviceResponseData>({
        url: '/device/register/v1',
        method: 'POST',
        requiresAuth: false,
    }),
};

export * from './typings';
